import { render, staticRenderFns } from "./failIndex.vue?vue&type=template&id=7d0454ed&scoped=true"
import script from "./failIndex.vue?vue&type=script&lang=js"
export * from "./failIndex.vue?vue&type=script&lang=js"
import style0 from "./failIndex.vue?vue&type=style&index=0&id=7d0454ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0454ed",
  null
  
)

export default component.exports